import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTadaIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 89,
	height: 88,
	viewBox: "0 0 89 88",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2159_9093)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M43.6797 6.24702C43.2354 4.7305 44.1087 3.14241 45.6333 2.72645C47.0728 2.33368 48.577 3.13058 49.0028 4.56066C51.7427 13.7605 52.7213 24.5158 40.8843 37.4816C39.8385 38.6271 38.0473 38.629 36.9504 37.5323C35.88 36.462 35.8635 34.7325 36.8546 33.5884C47.2431 21.5959 46.0466 14.3246 43.6797 6.24702Z",
				fill: "#ED8B00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M87.4513 39.5476C88.6507 40.5057 88.6403 42.2839 87.5549 43.3694C86.4858 44.4384 84.772 44.4302 83.5456 43.5461C76.4896 38.4596 67.9264 40.3991 56.4974 51.1502C55.391 52.1909 53.6477 52.2005 52.5737 51.1265C51.4996 50.0524 51.499 48.304 52.6073 47.2653C64.7689 35.8683 77.1857 31.348 87.4513 39.5476Z",
				fill: "#9BD3DD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M84.6591 0.0866516C85.8606 -0.0169731 86.9191 0.805803 87.2364 1.96935C87.7002 3.6703 86.4187 5.26629 84.6568 5.32972C82.5799 5.40448 80.8575 5.84087 78.9209 7.77738C76.0041 10.6942 77.9485 12.6385 74.5455 16.0415C71.1426 19.4444 68.226 18.4724 65.3091 21.3892C63.3726 23.3257 62.9362 25.0481 62.8615 27.1251C62.7981 28.8869 61.2021 30.1684 59.5012 29.7044C58.3381 29.3872 57.5155 28.3292 57.6189 27.128C57.9145 23.6918 58.9956 19.9242 61.4199 17.4999C64.3367 14.5831 67.7396 15.0692 70.6564 12.1524C73.5733 9.23559 72.1137 6.80342 75.031 3.88745C77.4556 1.46402 81.223 0.382978 84.6591 0.0866516Z",
				fill: "#CD4C08"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.6562 7.89282C28.6562 6.37404 29.8875 5.14282 31.4062 5.14282C32.925 5.14282 34.1562 6.37404 34.1562 7.89282C34.1562 9.41161 32.925 10.6428 31.4062 10.6428C29.8875 10.6428 28.6562 9.41161 28.6562 7.89282Z",
				fill: "#9BD3DD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.4375 18.8928C33.4375 17.374 34.6687 16.1428 36.1875 16.1428C37.7063 16.1428 38.9375 17.374 38.9375 18.8928C38.9375 20.4116 37.7063 21.6428 36.1875 21.6428C34.6687 21.6428 33.4375 20.4116 33.4375 18.8928Z",
				fill: "#9BD3DD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.5625 3.76782C59.5625 2.24904 60.7937 1.01782 62.3125 1.01782C63.8313 1.01782 65.0625 2.24904 65.0625 3.76782C65.0625 5.28661 63.8313 6.51782 62.3125 6.51782C60.7937 6.51782 59.5625 5.28661 59.5625 3.76782Z",
				fill: "#ED8B00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M80.1875 24.3928C80.1875 22.874 81.4187 21.6428 82.9375 21.6428C84.4563 21.6428 85.6875 22.874 85.6875 24.3928C85.6875 25.9116 84.4563 27.1428 82.9375 27.1428C81.4187 27.1428 80.1875 25.9116 80.1875 24.3928Z",
				fill: "#9BD3DD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70.5625 50.5176C70.5625 48.9988 71.7937 47.7676 73.3125 47.7676C74.8313 47.7676 76.0625 48.9988 76.0625 50.5176C76.0625 52.0364 74.8313 53.2676 73.3125 53.2676C71.7937 53.2676 70.5625 52.0364 70.5625 50.5176Z",
				fill: "#ED8B00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M75.4062 61.5176C75.4062 59.9988 76.6375 58.7676 78.1562 58.7676C79.675 58.7676 80.9062 59.9988 80.9062 61.5176C80.9062 63.0364 79.675 64.2676 78.1562 64.2676C76.6375 64.2676 75.4062 63.0364 75.4062 61.5176Z",
				fill: "#ED8B00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.4044 26.9338C27.1271 25.087 29.5076 24.5891 30.9099 25.9914L63.4634 58.5449C64.8657 59.9472 64.3678 62.3277 62.521 63.0504L9.04016 83.9776C6.80698 84.8515 4.60329 82.6478 5.47714 80.4146L26.4044 26.9338Z",
				fill: "#FDDA24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.2031 42.7833L22.3341 37.3384L52.6002 66.9318L46.6719 69.2521L20.2031 42.7833Z",
				fill: "#ED8B00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.8203 59.0901L15.9761 53.582L36.1943 73.3517L30.3633 75.6331L13.8203 59.0901Z",
				fill: "#ED8B00"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61 63.645L25.8086 28.4536L26.4034 26.9336C27.1259 25.0873 29.5066 24.5891 30.9091 25.991L63.4626 58.5452C64.8645 59.947 64.367 62.3278 62.52 63.0502L61 63.645Z",
				fill: "#EAAA00"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2159_9093",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 88,
			height: 88,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgTadaIcon);
export default ForwardRef;
